import React, { useState } from 'react';
import './MenuHamburger.css'; 
import { Link } from 'react-router-dom';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  return (
<div>
    <div className="hamburger-menu">
        <button className="hamburger-icon" onClick={toggleMenu}>
          ☰
        </button>
        {isOpen && (
          <nav className="menu">
            <ul>
              <li><Link to="/"          id="" onClick={toggleMenu}>Home</Link></li>
              <li><Link to="/solucoes"  id="" onClick={toggleMenu}>Soluções</Link></li>
              <li><Link to="/programas" id="" onClick={toggleMenu}>Programas e Sistemas</Link></li>
              <li><Link to="/sobre"     id="" onClick={toggleMenu}>Sobre a Criar</Link></li>
              <li><Link to="/fale"      id="" onClick={toggleMenu}>Fale Conosco</Link></li>
              <li><Link to="/area"      id="" onClick={toggleMenu}>Área Restrita</Link></li>
            </ul>
          </nav>
        )}
    </div>
    <div className="top-menu">
    <nav id="menubar">
      <Link to="/"          id="menubaritem">Home</Link>
      <Link to="/solucoes"  id="menubaritem">Soluções</Link>
      <Link to="/segmentos" id="menubaritem">Segmentos</Link>
      <Link to="/programas" id="menubaritem">Programas e Sistemas</Link>
      <Link to="/sobre"     id="menubaritem">Sobre a Criar</Link>
      <Link to="/fale"      id="menubaritem">Fale Conosco</Link>
      <Link to="/area"      id="menubaritem">Área Restrita</Link>
    </nav>
    </div>
</div>    
  );
};


export default Navbar;